import React from 'react';
import ReactDOM from 'react-dom/client';
import Routes from './routes';
import { restoreSession } from './services/AuthService';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Wait for the refresh cookie to restore the session, so PrivateRoute already
// knows whether there is a token on the first render.
restoreSession().finally(() =>
    root.render(
        <React.StrictMode>
            <Routes />
        </React.StrictMode>,
    ),
);
